import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './Logo';
import { SIGNIN_URL, BOOK_URL } from '../siteConfig';

const { FiMenu, FiX, FiArrowUpRight } = FiIcons;

function Header() {
  const [open, setOpen] = useState(false);
  const [slim, setSlim] = useState(false);
  const close = () => setOpen(false);

  useEffect(() => {
    const onScroll = () => setSlim(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={slim ? 'header-wrap slim' : 'header-wrap'}>
      <header className="header">
        <a className="brand" href="#/" aria-label="Handle My Tech home">
          <Logo />
        </a>
        <button className="menu-button" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          <SafeIcon icon={open ? FiX : FiMenu} />
        </button>
        <nav className={open ? 'nav open' : 'nav'}>
          <a href="#/services" onClick={close}>Services</a>
          <a href="#/how-it-works" onClick={close}>How it works</a>
          <a href="#/pricing" onClick={close}>Pricing</a>
          <a href={SIGNIN_URL} onClick={close}>Sign in</a>
          <a className="nav-cta" href={BOOK_URL} onClick={close}>
            Book a call <SafeIcon icon={FiArrowUpRight} />
          </a>
        </nav>
      </header>
    </div>
  );
}

export default Header;
